module.exports = __webpack_public_path__ + "img/1.5db9866b.jpg";